/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationValueDtoValue } from './EnumerationValueDtoValue';
import {
    EnumerationValueDtoValueFromJSON,
    EnumerationValueDtoValueFromJSONTyped,
    EnumerationValueDtoValueToJSON,
} from './EnumerationValueDtoValue';
import type { EnumerationOptionDto } from './EnumerationOptionDto';
import {
    EnumerationOptionDtoFromJSON,
    EnumerationOptionDtoFromJSONTyped,
    EnumerationOptionDtoToJSON,
} from './EnumerationOptionDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface EnumerationValueDto
 */
export interface EnumerationValueDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {EnumerationValueDtoValue}
     * @memberof EnumerationValueDto
     */
    value?: EnumerationValueDtoValue | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationValueDto
     */
    isUsedForEvaluation?: boolean;
    /**
     * 
     * @type {Array<EnumerationOptionDto>}
     * @memberof EnumerationValueDto
     */
    options?: Array<EnumerationOptionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationValueDto
     */
    $type?: EnumerationValueDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationValueDtoTypeEnum = typeof EnumerationValueDtoTypeEnum[keyof typeof EnumerationValueDtoTypeEnum];



/**
 * Check if a given object implements the EnumerationValueDto interface.
 */
export function instanceOfEnumerationValueDto(value?: unknown): value is EnumerationValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationValueDtoTypeEnum)[0];
}

export function EnumerationValueDtoFromJSON(json: any): EnumerationValueDto {
    return EnumerationValueDtoFromJSONTyped(json, false);
}

export function EnumerationValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'value': json['value'] == null ? undefined : EnumerationValueDtoValueFromJSON(json['value']),
        'isUsedForEvaluation': json['isUsedForEvaluation'] == null ? undefined : json['isUsedForEvaluation'],
        'options': json['options'] == null ? undefined : ((json['options'] as Array<any>).map(EnumerationOptionDtoFromJSON)),
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationValueDtoToJSON(value?: EnumerationValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'name': value['name'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'value': EnumerationValueDtoValueToJSON(value['value']),
        'isUsedForEvaluation': value['isUsedForEvaluation'],
        'options': value['options'] == null ? undefined : ((value['options'] as Array<any>).map(EnumerationOptionDtoToJSON)),
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        '$type': value['$type'],
    });
}

